module.exports = ".modal-footer {\r\n    text-align: right;\r\n}\r\n\r\n.row h6 {\r\n    font-weight: bold;\r\n}\r\n\r\n#group-form {\r\n    max-height: 450px;\r\n}\r\n\r\n.modal-footer {\r\n    margin-bottom: 10px!important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/partials/confirm-create/confirm-create.component.css
// module id = ./src/app/pages/partials/confirm-create/confirm-create.component.css
// module chunks = main